<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  interface Props {
    title: string
    section: string
    headings: any[]
    onupdateHeadings: (headings: any[]) => void
  }

  let props = $props()
  let {
    title = "",
    section = "",
    headings = [],
    onupdateHeadings
  }: Props = props

  let heading = $state(
    headings.find((h) => h.section === section)?.title || title
  )

  const canEdit = appStore.current_user?.role === "admin"

  async function edit(): Promise<void> {
    if (canEdit) {
      const newTitle = prompt("Section title", heading)

      if (newTitle && newTitle.trim() !== "") {
        try {
          await xhr.post(`/plans/${appStore.plan.id}/headings`, {
            section,
            title: newTitle
          })
          heading = newTitle

          let updated_headings = headings.map((h) =>
            h.section === section ? { ...h, title: newTitle } : h
          )
          headings = updated_headings
          onupdateHeadings(headings)
        } catch (e) {
          if (typeof Honeybadger.notify !== "undefined") {
            Honeybadger.notify(e)
          }
          toast("There was an error saving the new title", "error")
        }
      } else if (newTitle?.trim() === "") {
        alert("Title must not be empty!")
      }
    }
  }
</script>

<button class:cursor-pointer={canEdit} onclick={edit} tabindex="0">
  {heading}
</button>
